import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Button, Table } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { AccessRightService } from '../AccessRightService';
import { IAccessRights } from '../../../model/access-right/IAccessRight';
import { FaPlus } from 'react-icons/fa';
import { getCorrectEnums } from '../../../utils/Functions';
import { ErrorToast } from '../../../utils/toasters';
import TableLayout from '../../../shared/layout/table/TableLayout';
import { ITableColumn } from '../../../shared/components/TableSkeleton';

const ACCESS_RIGHT_COLUMNS: ITableColumn[] = [
    { label: 'ID' },
    { label: 'Name' },
    { label: 'Action', className: 'text-end' },
];

export default function AccessRight() {
    const navigate = useNavigate();

    const [dataLoading, setDataLoading] = useState<boolean>(true);
    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 15,
    });
    const [totalPages, setTotalPages] = useState(0);
    const [accessRightsList, setAccessRightsList] = useState<IAccessRights[]>([]);

    const handlePages = (updatePage: number) => {
        setPagination(prev => ({ ...prev, page: updatePage }));
    };

    useEffect(() => {
        let isCurrent = true;
        setDataLoading(true);

        AccessRightService.getAccessRights(pagination)
            .then(data => {
                if (!isCurrent) return;
                setAccessRightsList(data.data);
                setTotalPages(Math.ceil(data.count / pagination.perPage));
            })
            .catch(err => {
                if (isCurrent) ErrorToast(err);
            })
            .finally(() => {
                if (isCurrent) setDataLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [pagination.page]);

    return (
        <div>
            <Button
                className="d-flex align-items-center"
                variant="outline-primary"
                onClick={() => navigate('/access-right/form')}
            >
                <FaPlus className="mr-1" />
                <div>Create Sharing Right</div>
            </Button>

            <TableLayout
                listLength={accessRightsList.length}
                handlePages={handlePages}
                pagination={{ ...pagination, totalPages }}
                isLoading={dataLoading}
                dataName={'rights'}
                skeletonColumns={ACCESS_RIGHT_COLUMNS}
                skeletonRows={pagination.perPage}
            >
                <Table hover responsive>
                    <thead>
                        <tr>
                            {ACCESS_RIGHT_COLUMNS.map(column => (
                                <th key={column.label} className={column.className}>
                                    {column.label}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {accessRightsList.map(item => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{getCorrectEnums(item.name)}</td>
                                <td className="text-end">
                                    <NavLink
                                        className="btn btn-primary"
                                        to={{
                                            pathname: '/access-right/form/' + item.id,
                                        }}
                                    >
                                        Edit
                                    </NavLink>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </TableLayout>
        </div>
    );
}
